export default __webpack_public_path__ + "static/media/AUDIO_ICONA.a9c4557c.svg";